import React from 'react';
import Helmet from 'react-helmet';
import Slider from 'react-slick';
import classNames from 'classnames';

import Card from './Card/Card';

import css from './CardsCarousel.module.scss';

const CardsCarousel = ({ heading, description, data, customClass }) => {
	const settings = {
		dots: true,
		speed: 500,
		slidesToShow: 1,
		rows: 2,
		slidesPerRow: 3,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					rows: 1,
					slidesPerRow: 1,
					autoplay: true,
					speed: 1000,
					autoplaySpeed: 3000,
				},
			},
		],
	};
	return (
		<>
			<Helmet>
				<link
					rel="stylesheet"
					type="text/css"
					charset="UTF-8"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
				/>
				<link
					rel="stylesheet"
					type="text/css"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
				/>
			</Helmet>
			<section className={classNames(css.cardsCarousel, css[customClass])}>
				{heading && <h2 data-aos="fade-up">{heading}</h2>}
				{description && <p data-aos="fade-up">{description}</p>}
				<Slider {...settings}>
					{data.map(props => (
						<Card key={props.id} {...props} />
					))}
				</Slider>
			</section>
		</>
	);
};

export default CardsCarousel;
